import type { BmiCalculatorState } from "./types";

export const bmiStorageKey = "pyeah-bmi-state-v1";

export const defaultBmiState: BmiCalculatorState = {
  unitSystem: "metric",
  imperialHeightMode: "feet-inches",
  imperialWeightMode: "pounds",
  heightCentimetres: "",
  weightKilograms: "",
  heightFeet: "",
  heightInches: "",
  heightTotalInches: "",
  weightPounds: "",
  weightStones: "",
  weightStonePounds: ""
};
